type ROW_INFO = {
  defaultClass: string | null;
  settingGroups: {
    [key: string]: {
      [key: string]: {
        selector: string;
        inherit?: string; // (subType|type).key
        cssAttr?: string;
        listUnit?: string;
      };
    };
  } | null;
};

export const ROWS_MAP: Record<any, ROW_INFO> = {
  row: {
    defaultClass: null,
    settingGroups: null,
  },
};
